export const customWorkQSlugs = [
    'police-report',
    'drivers-license-mismatch',
    'invalid-fax-q',
]

/** Custom work queues that use `getGlobalWorkQ` and should show Q-Search in the controls bar. */
export const missedApptsFollowUpWorkQSlugs = [
    'missed-appts-fu-front-desk',
    'missed-appts-fu-management',
]

/** All slugs handled by frontend CustomWorkQs + merge in systemData (Header path sync, etc.). */
export const allFrontendCustomWorkQSlugs = [
    ...customWorkQSlugs,
    ...missedApptsFollowUpWorkQSlugs,
]

export const customWorkQsStructure = [
    // {
    //     id: 12345,
    //     name: "Global Discharge",
    //     slug: 'work-queues-global',
    //     type: 'custom',
    //     grouped_fields: [],
    //     filters: {
    //         // gdq_status_id: true,
    //         // aica_location: true
    //     }
    // },
    // {
    //     id: 123456,
    //     name: "Medical Records",
    //     slug: 'work-queues-medical-records',
    //     type: 'custom',
    //     grouped_fields: [],
    //     filters: {}
    // },
    // {
    //     id: 1234567,
    //     name: "Verification",
    //     slug: 'verification',
    //     apiSlug: 'work-queues-verification',
    //     type: 'custom',
    //     grouped_fields: [],
    //     filters: {}
    // },
    // {
    //     id: 12345678,
    //     name: "Case Level",
    //     slug: 'case-level',
    //     apiSlug: 'work-queues-case-level',
    //     type: 'custom',
    //     grouped_fields: [],
    //     filters: {}
    // },
    // {
    //     id: 123456789,
    //     name: "Undetermined",
    //     slug: 'undetermined',
    //     apiSlug: 'work-queues-undetermined',
    //     type: 'custom',
    //     grouped_fields: [],
    //     filters: {}
    // },
    // {
    //     id: 1234567891,
    //     name: "SOS",
    //     slug: 'sos',
    //     apiSlug: 'work-queues-sos',
    //     type: 'custom',
    //     grouped_fields: [],
    //     filters: {}
    // },
    {
        id: 123456789122,
        name: "Police Report",
        slug: 'police-report',
        apiSlug: 'work-queues-police-reports',
        type: 'custom',
        grouped_fields: [],
        filters: {}
    },
    {
        id: 6666666,
        name: "Drivers License Mismatch",
        slug: 'drivers-license-mismatch',
        apiSlug: 'work-queues-mismatched',
        type: 'custom',
        grouped_fields: [],
        filters: {}
    },
    {
        id: 6666667,
        name: "Invalid Fax Q",
        slug: 'invalid-fax-q',
        apiSlug: 'work-queues-invalid-fax',
        type: 'custom',
        grouped_fields: [],
        filters: {}
    },
    // {
    //     id: 123456789123,
    //     name: "Surgery RFS",
    //     slug: 'surgeries-rfs',
    //     apiSlug: 'work-queues-surgeries/rfs',
    //     type: 'custom',
    //     isSurgery: true,
    //     grouped_fields: [],
    //     filters: {}
    // },
    // {
    //     id: 1234567891234,
    //     name: "Surgery AFS",
    //     slug: 'surgeries-afs',
    //     apiSlug: 'work-queues-surgeries/afs',
    //     type: 'custom',
    //     isSurgery: true,
    //     grouped_fields: [],
    //     filters: {}
    // },
    // {
    //     id: 12345678912345,
    //     name: "Surgery BFS",
    //     slug: 'surgeries-bfs',
    //     apiSlug: 'work-queues-surgeries/bfs',
    //     type: 'custom',
    //     isSurgery: true,
    //     grouped_fields: [],
    //     filters: {}
    // },
    {
        id: 1234567891234589,
        name: "Missed Appts FU (Front Desk)",
        slug: 'missed-appts-fu-front-desk',
        apiSlug: 'work-queues-call-follow-ups?type=front_desk',
        type: 'custom',
        grouped_fields: [],
        filters: {}
    },
    {
        id: 555555,
        name: "Missed Appts FU (Management)",
        slug: 'missed-appts-fu-management',
        apiSlug: 'work-queues-call-follow-ups?type=clinic_practice_manager',
        type: 'custom',
        grouped_fields: [],
        filters: {}
    }
]